import PrivacyPolicy from "./policy";
function App() {
  return (
    <div>
      <PrivacyPolicy />
    </div>
  );
}
export default App;
